<template>
  <nav class="bg-(--p-background-50) border-b border-background-200 shadow-lg relative top-0 z-50">
    <div class="max-w-screen-2xl mx-auto h-16 flex items-center justify-between px-2">
      <div class="flex items-center gap-12">
        <router-link to="/" class="text-xl font-semibold text-color no-underline">
          <img :src="currentLogo" alt="Scope E-inspectie" class="h-10 w-auto">
        </router-link>
      </div>
      <div class="flex items-center gap-2">
        <NotificationBell v-if="authStore.user" />
        <div v-if="authStore.user"
          class="relative flex items-center cursor-pointer p-2 rounded transition-colors hover:bg-(--p-background-100)"
          @click="toggleMenu" ref="menuTrigger">
          <div class="w-6 h-6 flex items-center justify-center cursor-pointer text-color">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
              class="w-full h-full">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </div>
          <Transition name="menu">
            <div class="absolute top-full right-0 mt-2 bg-(--p-background-0) rounded-lg shadow-lg min-w-60 z-50"
              v-if="isMenuOpen" ref="menuDropdown">
              <div class="p-4 border-b border-background-200">
                <div class="text-left">
                  <div class="font-medium text-color">{{ userName }}</div>
                  <div class="text-sm text-background-500 mt-0.5">{{ userEmail }}</div>
                </div>
              </div>
              <div class="py-2">
                <div class="py-2">
                  <router-link to="/"
                    class="flex items-center px-4 py-2 no-underline transition-colors hover:bg-background-100 cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    <span>Dashboard</span>
                  </router-link>
                  <router-link to="/offertes"
                    class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Offertes</span>
                  </router-link>
                  <router-link to="/facturen"
                    class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                    <span>Facturen</span>
                  </router-link>
                  <router-link to="/rapporten"
                    class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Rapporten</span>
                  </router-link>
                  <router-link to="/documenten"
                    class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 13h6m-6 4h4m5 4H6a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Documenten</span>
                  </router-link>
                </div>
                <div class="h-px bg-background-200 mx-4 my-2"></div>
                <router-link to="/profile"
                  class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>Mijn Profiel</span>
                </router-link>
                <div
                  class="flex items-center px-4 py-2 text-color transition-colors hover:bg-background-100 cursor-pointer"
                  @click="toggleTheme">
                  <svg v-if="isDark" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                  </svg>
                  <span>{{ isDark ? 'Lichte modus' : 'Donkere modus' }}</span>
                </div>
                <router-link to="/options"
                  class="flex items-center px-4 py-2 text-color no-underline transition-colors hover:bg-background-100 cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span>Opties</span>
                </router-link>
                <div class="h-px bg-background-200 mx-4 my-2"></div>
                <div
                  class="flex items-center px-4 py-2 text-color transition-colors hover:bg-background-100 cursor-pointer"
                  @click="handleLogout">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span>Uitloggen</span>
                </div>
              </div>
            </div>
          </Transition>
        </div>
        <div v-else class="p-2 rounded cursor-pointer transition-colors hover:bg-background-100" @click="toggleTheme">
          <div class="w-6 h-6 flex items-center justify-center cursor-pointer text-color">
            <svg v-if="isDark" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-full h-full" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted, onUnmounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useAuthStore } from '../stores/auth'
  import { useOpdrachtgeverStore } from '../stores/opdrachtgever'
  import { useThemeStore } from '../stores/theme.ts'
  import NotificationBell from './NotificationBell.vue'
  import logoLight from '../assets/logoLight.svg'
  import logoDark from '../assets/logoDark.svg'

  const authStore = useAuthStore()
  const opdrachtgeverStore = useOpdrachtgeverStore()
  const themeStore = useThemeStore()
  const router = useRouter()
  const isMenuOpen = ref(false)
  const menuTrigger = ref<HTMLElement | null>(null)
  const menuDropdown = ref<HTMLElement | null>(null)

  const isDark = computed(() => themeStore.isDark)
  const currentLogo = computed(() => themeStore.isDark ? logoDark : logoLight)
  const userName = computed(() => opdrachtgeverStore.opdrachtgever?.contactnaam || authStore.user?.user_metadata?.full_name || 'Gebruiker')
  const userEmail = computed(() => authStore.user?.email || '')

  const toggleTheme = () => {
    themeStore.toggleTheme()
  }

  // Only fills in the display name; a failure here must never surface as an
  // unhandled rejection, since onMounted cannot await it. userName falls back
  // to the auth metadata name.
  const loadOpdrachtgever = async () => {
    if (!authStore.user?.id) return
    try {
      await opdrachtgeverStore.getOpdrachtgeverById(authStore.user.id)
    } catch (err) {
      console.error('Kon opdrachtgevergegevens niet laden voor de navigatie:', err)
    }
  }

  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      isMenuOpen.value &&
      menuTrigger.value &&
      menuDropdown.value &&
      !menuTrigger.value.contains(event.target as Node) &&
      !menuDropdown.value.contains(event.target as Node)
    ) {
      isMenuOpen.value = false
    }
  }

  const handleLogout = async () => {
    try {
      await authStore.logout()
    } catch (error) {
      console.error('Logout failed:', error)
    }
    isMenuOpen.value = false
    router.push('/login')
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    loadOpdrachtgever()
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
  })
</script>

<style scoped>

  .menu-enter-active,
  .menu-leave-active {
    transition: all 0.2s ease;
    transform-origin: top right;
  }

  .menu-enter-from,
  .menu-leave-to {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }

  .menu-enter-to,
  .menu-leave-from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
</style>
